/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import { v4 as uuidv4 } from 'uuid';

const __vue_script__ = {
    name: 'FormScheduler',

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            required: true
        },

        name: {
            type: String,
            default: null
        },

        value: {
            type: Object,
            required: true
        },

        sentPropertyConfig: {
            type: Object,
            required: true
        },

        expirePropertyConfig: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            deliveryDeltaMinutes: null,
            expireProperty: null,
            is_visible_after_submitting: null,
            isInDetails: null,
            isNotificationEnabled: null,
            pageName: null,
            pageId: null,
            id: null,
            sentProperty: null,

            ready: false,
            sentPropertyOptions: { list_style: 'select', values: {} },
            expirePropertyOptions: { list_style: 'select', values: {} }
        };
    },

    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(value) {
                this.deliveryDeltaMinutes = value.deliveryDeltaMinutes;
                this.expireProperty = value.expireProperty;
                this.is_visible_after_submitting = value.is_visible_after_submitting;
                this.isInDetails = value.isInDetails;
                this.isNotificationEnabled = value.isNotificationEnabled;
                this.pageName = value.name;
                this.pageId = value.pageId;
                // Fix a bug where the _id was discarded by mistake
                this.id = value._id || uuidv4();
                this.sentProperty = value.sentProperty;
            }
        }
    },

    created() {
        this.init();
    },

    methods: {
        async init() {
            try {
                // this was only used for "session" until we added forms to meetings
                // the parent component has a "relatedModel" but that is unfortunately "questionnaire"
                // so this is the only way i could think of to know we are talking about meetings
                const type = globalThis.location.pathname.includes('/meetings/')
                    ? 'meeting'
                    : 'session';
                const md = await this.$services.metadata.getMetadataForType(this.event._id, type);

                this.sentPropertyConfig.values.forEach(value => {
                    this.sentPropertyOptions.values[value] = md[value].label;
                });

                this.expirePropertyConfig.values.forEach(value => {
                    this.expirePropertyOptions.values[value] = md[value].label;
                });
            } catch (error) {
                console.error('[FormScheduler] Error while fetching metadata', error);
            } finally {
                this.ready = true;
            }
        },

        applyChanges() {
            this.updateValue();
        },

        updateValue() {
            this.$emit('input', {
                deliveryDeltaMinutes: this.deliveryDeltaMinutes,
                expireProperty: this.expireProperty,
                is_visible_after_submitting: this.is_visible_after_submitting,
                isInDetails: this.isInDetails,
                isNotificationEnabled: this.isNotificationEnabled,
                name: this.pageName,
                pageId: this.pageId,
                sentProperty: this.sentProperty,
                _id: this.id
            });
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        { staticClass: "form-scheduler boxed-content" },
        [
          _c("meta-control", {
            attrs: {
              name: "form-scheduler-page-name",
              control: { label: _vm.$t("agenda.forms.page_name") },
            },
            model: {
              value: _vm.pageName,
              callback: function ($$v) {
                _vm.pageName = $$v
              },
              expression: "pageName",
            },
          }),
          _c("meta-control", {
            attrs: {
              name: "form-scheduler-sent-property",
              control: {
                kind: "choice",
                label: _vm.$t("agenda.forms.sent_property"),
                kind_options: _vm.sentPropertyOptions,
              },
            },
            model: {
              value: _vm.sentProperty,
              callback: function ($$v) {
                _vm.sentProperty = $$v
              },
              expression: "sentProperty",
            },
          }),
          _vm.sentProperty
            ? [
                _c("meta-control", {
                  attrs: {
                    name: "form-scheduler-delivery-delta-minutes",
                    control: {
                      label: _vm.$t("agenda.forms.delivery_delta_minutes"),
                      kind: "number",
                      kind_options: { step: 1 },
                      tooltip: _vm.$t(
                        "agenda.forms.delivery_delta_minutes_tooltip"
                      ),
                    },
                    dependant: true,
                  },
                  model: {
                    value: _vm.deliveryDeltaMinutes,
                    callback: function ($$v) {
                      _vm.deliveryDeltaMinutes = $$v
                    },
                    expression: "deliveryDeltaMinutes",
                  },
                }),
                _c("meta-control", {
                  attrs: {
                    name: "form-scheduler-is-notification-enabled",
                    control: {
                      label: _vm.$t("agenda.forms.is_notification_enabled"),
                      kind: "boolean",
                      tooltip: _vm.$t(
                        "agenda.forms.is_notification_enabled_tooltip"
                      ),
                    },
                    dependant: true,
                  },
                  model: {
                    value: _vm.isNotificationEnabled,
                    callback: function ($$v) {
                      _vm.isNotificationEnabled = $$v
                    },
                    expression: "isNotificationEnabled",
                  },
                }),
              ]
            : _vm._e(),
          _c("meta-control", {
            attrs: {
              name: "form-scheduler-expire-property",
              control: {
                kind: "choice",
                label: _vm.$t("agenda.forms.expire_property"),
                kind_options: _vm.expirePropertyOptions,
              },
            },
            model: {
              value: _vm.expireProperty,
              callback: function ($$v) {
                _vm.expireProperty = $$v
              },
              expression: "expireProperty",
            },
          }),
          _c("meta-control", {
            attrs: {
              name: "form-scheduler-is-in-details",
              control: {
                label: _vm.$t("agenda.forms.is_in_details"),
                kind: "boolean",
                tooltip: _vm.$t("agenda.forms.is_in_details_tooltip"),
              },
            },
            model: {
              value: _vm.isInDetails,
              callback: function ($$v) {
                _vm.isInDetails = $$v
              },
              expression: "isInDetails",
            },
          }),
          _c("meta-control", {
            attrs: {
              name: "form-scheduler-is-visible-after-submitting",
              control: {
                label: _vm.$t("agenda.forms.is_visible_after_submitting"),
                kind: "boolean",
              },
            },
            model: {
              value: _vm.is_visible_after_submitting,
              callback: function ($$v) {
                _vm.is_visible_after_submitting = $$v
              },
              expression: "is_visible_after_submitting",
            },
          }),
          _c("div", { staticClass: "btn-group important" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("general.cancel")))]
            ),
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.applyChanges()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("general.apply")))]
            ),
          ]),
        ],
        2
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/pickers/FormScheduler.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__